const styles = {
  mainContainer: {
    width: "80%",
    marginLeft: "40px",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    fontFamily: '"Poppins", sans-serif',
    color: "#000000",
    textAlign: "left",
  },
  addressSection: {
    display: "grid",
    gridTemplateColumns: "30% 30%",
    gap: "40px",
    marginTop: "16px",
  },
  billingAddress: {
    flexDirection: "column",
    gap: "20px",
  },
  shippingAddress: {
    flexDirection: "column",
    gap: "20px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: '"Poppins", sans-serif',
    color: "#181818",
    marginBottom: "16px",
    textAlign: "left",
  },
  addressCard: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "20px 10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
  },
  addressDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "70%",
    textAlign: "left",
  },
  editIcon: {
    height: "24px",
    width: "24px",
    cursor: "pointer",
  },
  textWithSwitch: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "16px",
  },
  mobileNoText: {
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: '"Poppins", sans-serif',
    color: "#9C7726",
  },
  changeAddressButton: {
    backgroundColor: "#9C7726",
    height: "32px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "16px",
    color: "white",
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: '"Poppins", sans-serif',
  },
  blackTextStyle: {
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: '"Poppins", sans-serif',
    color: "#000000",
  },
  switchTextStyle: {
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: '"Poppins", sans-serif',
    color: "#000000",
    maxWidth: "180px",
    textAlign: "left",
  },
  plusIcon: {
    height: "30px",
    width: "30px",
    cursor: "pointer",
  },
  addressView: {
    backgroundColor: "white",
    border: "1px dashed #D3D3D3",
    justifyContent: "center",
    alignItems: "center",
    padding: "84px 20px",
    borderRadius: 6,
  },
  addAddressText: {
    fontSize: "18px",
    fontWeight: 600,
    fontFamily: '"Poppins", sans-serif',
    color: "#727272",
    marginTop: '9px'
  }
};

export default styles;
